import {
  BottomTabNavigationProp,
  createBottomTabNavigator,
} from "@react-navigation/bottom-tabs";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { PLUViewMode } from "../PLU/PLUViewMode";

export const TeamTab = createBottomTabNavigator<TeamTabParamList>();

export type TeamTabNavigationProp<T extends keyof TeamTabParamList> =
  CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"Team">,
    BottomTabNavigationProp<TeamTabParamList, T>
  >;
export type TeamTabRouteProp<T extends keyof TeamTabParamList> = RouteProp<
  TeamTabParamList,
  T
>;

type TeamTabParamList = {
  TeamHome: {
    teamId: string;
  };

  TeamPLU: {
    isEditing: boolean;
    isShowingAllCategories: boolean;
    searchText: string;
    searching: boolean;
    mode: PLUViewMode;
    selectedCategoryId?: string;
    teamId: string;
  };
  TeamFiles: {
    teamId: string;
  };
};
